import { motion } from 'framer-motion';

function Button({ children, type = "button", variant = "primary", className = "", ...props }) {
  const baseStyles = "px-4 py-2 rounded-md font-medium transition-all duration-300";
  const variants = {
    primary: "bg-primary-green text-white hover:bg-[#3d8b40] shadow-md hover:shadow-lg",
    outline: "border-2 border-primary-green text-primary-green hover:bg-primary-green hover:text-white shadow-md hover:shadow-lg",
    secondary: "bg-accent-yellow text-text-dark hover:bg-[#e6c200] shadow-md hover:shadow-lg"
  };

  return (
    <motion.button 
      type={type}
      className={`${baseStyles} ${variants[variant]} ${className}`}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      {...props}
    >
      {children}
    </motion.button>
  );
}

export default Button; 